import SearchModel from 'coreClasses/search/SearchModel';

import type {SSRResponse} from 'coreHooks/useSSRResponse';

import type {ICategoryResult} from './categoriesService';

/**
 * Adds SSR cache tags for a PLP response: category tree, product hits, CMS page, static includes.
 */
export const addCategoryPageCacheTags = (
	res: SSRResponse | null,
	category: ICategoryResult | null | undefined,
	searchModel: SearchModel | null | undefined,
	pageData: {page?: {sys?: {id?: string}}} | undefined,
	staticProductIds: Set<string>,
): void => {
	if (!res?.cacheTagManager) {
		return;
	}

	const {cacheTagManager} = res;

	cacheTagManager.addCategoryTag();

	const categoryId = category?.getId();

	if (categoryId && category) {
		cacheTagManager.addCategoryTag(categoryId);
		category?.getParentCategoryTreeIds()?.forEach((id) => cacheTagManager.addCategoryTag(id));
	}

	searchModel?.getAllHits()?.forEach((hit) => {
		cacheTagManager.addProductTag(hit.getProductId());
	});

	if (pageData?.page?.sys?.id) {
		cacheTagManager.addContentfulTag(pageData.page.sys.id);
	}

	Array.from(staticProductIds).forEach((pid) => cacheTagManager.addProductTag(pid));
};
